<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Our Projects</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Our Projects</li>
            </ul>
        </div>
    </div>
</div>

<!--============ Our Projects ============= -->
<div class="case-area space">
    <div class="container">
        <div class="row justify-content-center text-center">
            <div class="col-xl-12">
                <span class="sub-title">Our Portfolio</span>
                <h2 class="sec-title text-center mb-30">Transforming Ideas into Innovations</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 mb-5">
                <div class="case-menu mb-5 text-center">
                    <button class="case4-btn active" data-filter=".case0">Laravel</button>
                    <button class="case4-btn" data-filter=".case1">WordPress</button>
                    <button class="case4-btn" data-filter=".case2">Next Js</button>
                    <button class="case4-btn" data-filter=".case3">React Js</button>
                    <button class="case4-btn" data-filter=".case4">Web Design</button>
                    <button class="case4-btn" data-filter=".case5">Mobile Apps</button>
                    <button class="case4-btn" data-filter=".case6">E-Commerce</button>
                    <button class="case4-btn" data-filter=".case7">Animation</button>
                    <button class="case4-btn" data-filter=".case8">Logo Design</button>
                </div>
            </div>
        </div>
        <div class="row gy-30 grid relative">
            <app-laravel></app-laravel>
            <app-wordpress></app-wordpress>
            <app-next-js></app-next-js>
            <app-react-js></app-react-js>
            <app-web-design></app-web-design>
            <app-mobile-app></app-mobile-app>
            <app-ecommerce></app-ecommerce>
            <app-animation></app-animation>
            <app-logo-designs></app-logo-designs>
        </div>
    </div>
</div>

<!--======== Footer Section ========-->
<app-footer></app-footer>